import Result from "@Core/Result";
import { ServiceBase } from "@Core/ServiceBase";
import {IRoleAssignmentDetails, IRoleDetails, IRolePayload} from "@Models/IRoleDetails";
import { IEntity } from "@Models/IEntity";

export default class RoleService extends ServiceBase {
  
  /*
   * Get full information about all possible roles, including associated capability details.
   */
  public async getAll(minimal = false): Promise<Result<IRolePayload>> {
    return await this.requestJson<IRolePayload>({
      url: `/api/Role/GetAll?minimal=${minimal}`,
      method: "GET",
    });
  }

  /*
   * Get user assignments for a given list of roles.
   */
  public async getUsers(roleIds: string[]): Promise<Result<IRoleAssignmentDetails[]>> {
    return await this.requestJson<IRoleAssignmentDetails[]>({
      url: `/api/Role/GetUsers/${roleIds.join(",")}`,
      method: "GET",
    });
  }

  /*
   * Create a new role from an existing, including applicable contexts, assigning an owner.
   */
  public async copy(ownerId: string, roleId: string): Promise<Result<IEntity>> {
    return await this.requestJson<IEntity>({
      url: `/api/Role/Copy/${ownerId}/${roleId}`,
      method: "POST",
    });
  }

  /*
   * Delete a role from the system.
   */
  public async delete(roleId: string): Promise<Result<number>> {
    return await this.requestJson<number>({
      url: `/api/Role/Delete/${roleId}`,
      method: "DELETE",
    });
  }

  /*
   * Update the basic details of an existing role, including applicable contexts.
   */
  public async update(model: IRoleDetails): Promise<Result<number>> {
    return await this.requestJson<number>({
      url: `/api/Role/Update/${model.roleId}`,
      method: "PATCH",
      data: model,
    });
  }
}
